<template>
    <div class="product-images" dir="ltr" style="direction: ltr">
        <carousel class="product-images-main" loop :pagination-enabled="false"
                  :per-page-custom="[[1500, 1], [1300, 1], [1200, 1], [992, 1], [768, 1], [576, 1], [360, 1], [200, 1]]">
            <slide v-for="(slide, index) in images" :key="index" dir="rtl">
                <picture>
                    <source :srcset="slide.url['webp-im']" type="image/webp">
                    <source :srcset="slide.url['im']" type="image/jpg">
                    <img :src="slide.url['im']" :alt="slide.alt" :title="slide.title" width="328" height="232"
                         @click.prevent="showModalBox(index)"/>
                </picture>
            </slide>
        </carousel>

        <carousel class="product-images-thumb" :pagination-enabled="false" scrollPerPage
                  :per-page-custom="[[1500, 4], [1300, 4], [1200, 4], [992, 4], [768, 4], [576, 5], [360, 5], [200, 3]]">
            <slide v-for="(slide, index) in images" :key="index" dir="rtl" :class="[active === index ? 'active' : '']">
                <picture>
                    <source :srcset="slide.url['webp-ic']" type="image/webp">
                    <source :srcset="slide.url['ic']" type="image/jpg">
                    <img :src="slide.url['ic']" :alt="slide.alt" :title="slide.title" :width="75" :height="54"
                         @click.prevent="setActive(index)"/>
                </picture>
            </slide>
        </carousel>


        <!-- Modal -->
        <div class="modal fade" id="product-images-modal-box" tabindex="-1" role="dialog"
             aria-labelledby="product-images-modal-box-label" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="product-images-modal-box-label">{{ title }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center" style="background: #000000;direction: ltr" dir="ltr">
                        <div style="height: 488px;">
                            <template v-if="showModalCarousel">
                                <carousel class="product-images-modal" loop :pagination-enabled="false"
                                          navigation-enabled
                                          :per-page-custom="[[1500, 1], [1300, 1], [1200, 1], [992, 1], [768, 1], [576, 1], [360, 1], [200, 1]]">
                                    <slide v-for="(slide, index) in images" :key="index" dir="rtl">
                                        <picture>
                                            <source :srcset="slide.url['webp-lg']" type="image/webp">
                                            <source :srcset="slide.url['lg']" type="image/jpg">
                                            <img :src="slide.url['lg']" :alt="slide.alt" :title="slide.title"
                                                 width="689" height="488"/>
                                        </picture>
                                    </slide>
                                </carousel>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';

export default {
    name: "product-images",
    components: {Carousel, Slide},
    data() {
        return {
            active: 0,
            showModalCarousel: false,
            modalIndex: 0,
        };
    },
    props: {
        images: {
            type: Array,
        },
        width: {
            type: String,
            default() {
                return '328';
            }
        },
        height: {
            type: String,
            default() {
                return '232';
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        }
    },
    methods: {
        setActive(index) {
            this.active = index;
            this.$children[0].$children[0].carousel.goToPage(index);
            if (this.$children[2] && this.$children[2].$children[0] && this.$children[2].$children[0].carousel) {
                this.$children[2].$children[0].carousel.goToPage(index);
            }
        },
        showModalBox(index) {
            this.modalIndex = index;
            $('#product-images-modal-box').modal('show');
        }
    },
    mounted() {
        //window.C = this;
        let self = this;
        $('#product-images-modal-box').on('shown.bs.modal', function (e) {
            self.showModalCarousel = true;
            window.setTimeout(function () {
                self.$children[2].$children[0].carousel.goToPage(self.modalIndex);
            }, 100);
        });
    }
}
</script>

<style>

</style>
